import axios from 'axios';
import { apiUrl, menuUrl } from '../env';
import { getAuthHeaders } from './utils';
import { AffiliateProduct } from '../interfaces/affiliate_products';
/* eslint-disable */

export const affiliateProductsApi = {
  async getMerchantProducts(id: number) {
    return axios.get<AffiliateProduct[]>(
      `${menuUrl}/api/v1/affiliate-products/${id}/products`,
      {
        headers: await getAuthHeaders(),
      },
    );
  },

  async getProduct(id: number) {
    return axios.get<AffiliateProduct>(
      `${menuUrl}/api/v1/affiliate-products/${id}`,
      {
        headers: await getAuthHeaders(),
      },
    );
  },
};
